/* eslint-disable */
import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Typography, Grid, Paper, TextField, Checkbox, FormControlLabel, Container } from '@mui/material';
import { Box } from '@mui/system';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { Link, useNavigate } from 'react-router-dom';
import CartItem from '../components/CartItem';
import { selectCartSubtotal } from '../redux/cartSlice'; // Import the selector

const Cart = () => {
  // Get the subtotal from the Redux store
  const subtotal = useSelector(selectCartSubtotal);
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  const cartItems = useSelector(state => state.cart.items);
  const totalAmount = useSelector(state => state.cart.totalAmount);
  const totalQuantity = useSelector(state => state.cart.totalQuantity);
  const [checked, setChecked] = React.useState(false);
  const navigate = useNavigate(); // Get the navigate function from react-router-dom

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const handleProceedToCheckout = () => {
    if (isAuthenticated) {
      console.log("checkout")
      // User is logged in, navigate to checkout page
      navigate('/checkout');
    } else {
      console.log("login")
      // User is not logged in, navigate to login page
      navigate('/login');
    }
  };

  return (
    <Container>
      <Typography variant="h3" gutterBottom sx={{ fontFamily: 'sans-serif' }}>My Cart</Typography>
      {cartItems.length === 0 ? (
        <Typography variant="body1">Your cart is empty.</Typography>
      ) : (
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <Grid>
              <Paper sx={{ display: 'flex', justifyContent: 'space-evenly', padding: 1 }}>
                {/* Product List */}
                <Typography variant="h6">Title</Typography>
                <Typography variant="h6">Quantity</Typography>
                <Typography variant="h6">Price</Typography>
                <Typography variant="h6">Delete</Typography>
              </Paper>
            </Grid>
              <Grid sx={{ marginTop: 2 }}>
                <Paper>
                  <CartItem  />
                </Paper>
              </Grid>

          </Grid>
          <Grid item xs={12} md={4}>
            <Grid>
              <Paper>
                {/* Coupons & Offers */}
                <Typography variant="h4" sx={{ marginLeft: 1, paddingTop: 1 }}>Coupons & Offers (if any)
                  <hr />
                </Typography>
                <TextField label="Enter Coupon Code" variant="outlined" sx={{ height: '70px', marginLeft: 1 }} />
                <Button variant="contained" color="primary" sx={{
                  height: '45px', marginLeft: 1, borderRadius: '8px', '&:hover': {
                    backgroundColor: '#1976d2',
                  },
                }}>APPLY</Button>
              </Paper>
            </Grid>
            <Grid sx={{ marginTop: 2 }}>
              <Paper>
                <Box sx={{ display: 'flex', marginLeft: 2 }}>
                  <FormControlLabel
                    control={<Checkbox checked={checked} onChange={handleChange} />}
                  />
                  <CardGiftcardIcon sx={{ marginTop: 1 }} />
                  <Typography sx={{ marginTop: '10px', marginLeft: 1, fontFamily: 'sans-serif', fontWeight: 'bold', fontSize: "16px" }}>Gift wrap this for ₹30</Typography>
                </Box>
              </Paper>
            </Grid>
            <Grid sx={{ marginTop: 2 }}>
              <Paper sx={{ height: '200px' }}>
                <Typography variant="h4" sx={{ marginLeft: 1, paddingTop: 1 }}>Order Summary</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-around', marginTop: 2 }}>
                  <Box>
                    <Typography>Subtotal ({totalQuantity} Items)</Typography>
                    <Typography sx={{ marginTop: 1 }}>Coupon Discount</Typography>
                    <Typography sx={{ marginTop: 1 }}>Total</Typography>
                  </Box>
                  <Box>
                    <Typography>₹ {Number(subtotal).toFixed(2)}</Typography>
                    <Typography sx={{ marginTop: 1 }}>₹ 0</Typography>
                    <Typography sx={{ marginTop: 1 }}>₹ {Number(subtotal).toFixed(2)}</Typography>
                  </Box>
                </Box>
                <hr />
                <Box sx={{ display: 'flex', justifyContent: 'space-around', marginTop: 1 }}>
                  <Box>
                    <Typography sx={{ fontFamily: 'sans-serif', fontWeight: 'bold', fontSize: '16px' }}>To Pay</Typography>
                  </Box>
                  <Box>
                    <Typography sx={{ fontFamily: 'sans-serif', fontWeight: 'bold', fontSize: '16px' }}>₹ {Number(subtotal).toFixed(2)}</Typography>
                  </Box>
                </Box>
              </Paper>
                <Button
                  variant="contained"
                  color="primary"
                  endIcon={<ArrowForwardIcon />}
                  onClick={handleProceedToCheckout}
                  sx={{
                    background: 'linear-gradient(to bottom, #FFA726, #FB8C00)',
                    color: 'white',
                    fontWeight: 'bold',
                    borderRadius: '20px',
                    padding: '10px 20px',
                    textTransform: 'uppercase',
                    width: '90%',
                    marginLeft: 2,
                    marginTop: 2
                  }}
                >
                  Proceed to Checkout
                </Button>
            </Grid>
            <Grid sx={{ marginTop: 2, marginBottom: 1 }}>
              <Paper sx={{ display: 'flex' }}>
                <LocalShippingIcon sx={{ marginTop: 2, marginLeft: 2 }} />
                <Typography sx={{ marginTop: '10px', marginLeft: 1, fontFamily: 'sans-serif', fontWeight: 'bold', fontSize: "16px" }}>Hooray! You have free shipping on this order.</Typography>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Container>
  );
};

export default Cart;
